import { useEffect, useRef, useState } from "react";
import { Table, Modal, Button } from "antd";
import { ErrorToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";

const DemoRequestsList = () => {
  const calledOnce = useRef(false);

  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  /* -------- Additional Notes Modal State -------- */
  const [notesModal, setNotesModal] = useState({
    open: false,
    text: "",
  });

  /* ---------------- DEMO REQUEST LIST API ---------------- */
  const DEMO_REQUEST_LIST_API = (page = 1) => {
    setLoading(true);

    const FORM_DATA = new FormData();

    // Send page only from page 2+
    if (page > 1) {
      FORM_DATA.append("page", page);
    }

    post(ApiURL.demo_request_list, FORM_DATA)
      .then((res) => {
        if (res?.status === true) {
          setListData(res?.results || []);
          setTotalRecords(res?.total_records || 0);
          setCurrentPage(res?.current_page || page);
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .catch((err) => {
        console.error("Demo request list error:", err);
      })
      .finally(() => setLoading(false));
  };

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    if (!calledOnce.current) {
      DEMO_REQUEST_LIST_API(1);
      calledOnce.current = true;
    }
  }, []);

  /* ---------------- TABLE COLUMNS ---------------- */
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      key: "email",
    },
    {
      title: "Contact",
      dataIndex: "phone_no",
      align: "center",
      key: "phone_no",
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
      render: (val) => val || "-",
    },
    {
      title: "Preferred Demo Date",
      dataIndex: "preferred_demo_date",
      align: "center",
      key: "preferred_demo_date",
      render: (val) => val || "-",
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      align: "center",
      key: "job_title",
      render: (val) => val || "-",
    },
    {
      title: "Additional Notes",
      dataIndex: "additional_notes",
      align: "center",
      key: "additional_notes",
      render: (text) =>
        text ? (
          <Button
            type="link"
            size="small"
            onClick={() =>
              setNotesModal({
                open: true,
                text,
              })
            }
          >
            View
          </Button>
        ) : (
          "-"
        ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (val) =>
        val ? new Date(val).toLocaleString() : "-",
    },
  ];

  return (
    <div>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6">
          <div className="theme-content-title">
            <h3>Demo Requests List</h3>
          </div>
        </div>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={listData}
        rowKey="id"
        loading={loading}
        className="custom-table"
        pagination={{
          current: currentPage,
          pageSize: 10,
          total: totalRecords,
          onChange: (page) => DEMO_REQUEST_LIST_API(page),
        }}
      />

      {/* -------- Additional Notes Modal -------- */}
      <Modal
        title="Additional Notes"
        open={notesModal.open}
        footer={null}
        onCancel={() => setNotesModal({ open: false, text: "" })}
      >
        <div
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {notesModal.text}
        </div>
      </Modal>
    </div>
  );
};

export default DemoRequestsList;
